import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { MtUser } from "server/models"
import { StateType, deepCopy } from "client/utils"
import {
    StoreType,
    TaskObjectProps,
    TaskObserverList,
    UserFilters,

    SortUsers,
    AddTaskObservers,
    LoadTaskObservers,

    setTaskObserverList,
    setNotAssignedTaskObserverIds,
    setNotAssignedTaskObserverSelected,
    setNotAssignedTaskObserverSort,
    setNotAssignedTaskObserverFilters,
    closeModal,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    PageForm,
    Button,
    TableSearchWrapper,
    Table,
    SortRows,
    SpinnerIcon,
} from "client/components"

import UserSearch from "client/pages/search/userSearch"
import Columns from "./columns"

let isMounted: boolean

const AddObservers = ({
    task,
}: TaskObjectProps) => {
    const project = useSelector((state: StoreType) => state.project.projectView)
    const userList = useSelector((state: StoreType) => state.user.userList)

    const accountUserList = useSelector((state: StoreType) => state.accountUser.accountUserList)
    const projectUserList = useSelector((state: StoreType) => state.projectUser.projectUserList)

    const taskObserverList = useSelector((state: StoreType) => state.taskObserver.taskObserverList)
    const userIds = useSelector((state: StoreType) => state.taskObserver.notAssignedUsers.userIds)
    const sortColumn = useSelector((state: StoreType) => state.taskObserver.notAssignedUsers.sortColumn)
    const sortOrder = useSelector((state: StoreType) => state.taskObserver.notAssignedUsers.sortOrder)
    const filters = useSelector((state: StoreType) => state.taskObserver.notAssignedUsers.filters)
    const selected = useSelector((state: StoreType) => state.taskObserver.notAssignedUsers.selected)

    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [saveState, setSaveState] = useState<StateType>(IDLE)

    useEffect(() => {
        isMounted = true
        return () => {
            isMounted = false
        }
    }, [])

    useEffect(() => {
        const sortedUserIds = SortUsers(Object.values(userList), sortColumn, sortOrder, filters)
        const availableUserIds = project.id
            ? (projectUserList && projectUserList[project.id]) || []
            : (accountUserList && accountUserList[userData.accountId]) || []

        const taskObservers = taskObserverList[task.id] || []
        const filteredUserIds = sortedUserIds.filter((userId) => (
            availableUserIds.includes(userId) && !taskObservers.includes(userId)
        ))
        dispatch(setNotAssignedTaskObserverIds(filteredUserIds))
        dispatch(setNotAssignedTaskObserverSelected([]))
    }, [accountUserList, projectUserList, sortColumn, sortOrder, filters])

    const onSort: SortRows = (column: keyof MtUser, order) => {
        dispatch(setNotAssignedTaskObserverSort(column, order))
    }

    const onFilter = (newFilters: UserFilters) => {
        dispatch(setNotAssignedTaskObserverFilters(newFilters))
        dispatch(setNotAssignedTaskObserverSelected([]))
    }

    const assignObservers = () => {
        setSaveState(PENDING)
        AddTaskObservers(selected, task.id).then(() => {
            LoadTaskObservers(task.id).then((res) => {
                const observerListCopy: TaskObserverList = deepCopy(taskObserverList)
                observerListCopy[task.id] = res
                dispatch(setTaskObserverList(observerListCopy))

                if (isMounted) {
                    setSaveState(IDLE)
                    dispatch(closeModal())
                }
            })
        })
    }

    const columns = Columns(task)

    return (
        <Container>
            <PageHeader>
                <PageTitle>{lang.addObserver_s}</PageTitle>
            </PageHeader>
            <PageContent>
                <TableSearchWrapper>
                    <UserSearch
                        id="taskObservers"
                        filters={filters}
                        onFilter={onFilter}
                    />
                </TableSearchWrapper>
                <Table
                    columns={columns}
                    dataList={userList}
                    dataIds={userIds}
                    selectedIds={selected}
                    sortColumn={sortColumn}
                    sortOrder={sortOrder}
                    rowSize="sm"
                    showPagination
                    onSort={onSort}
                />
                <PageForm>
                    <Button
                        variant="success"
                        disabled={!selected || selected.length === 0}
                        onClick={assignObservers}
                    >
                        {saveState === PENDING ? <SpinnerIcon /> : lang.select}
                    </Button>
                </PageForm>
            </PageContent>
        </Container>
    )
}
export default AddObservers
